import { Component, OnInit, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { HighStockService } from './high-stock.service';
import * as moment from 'moment';

@Component({
  selector: 'app-high-stock-chart',
  template: '<img class="preLoader" [hidden] ="chartReady" src="http://cloud.agroclimate.org/tools/kddMonitoring/assets/images/map.gif" />' +
            '<chart [hidden]="!chartReady" type="StockChart" [options]="options"></chart>',
  styleUrls: ['./high-stock-chart.component.sass']
})

export class HighStockChartComponent implements OnInit, OnChanges {
    //inputs from root component: ChartsComponent
    @Input()
    private selectedPeriod: number;
    @Input()
    private selectedBaseTemp: number;
    @Input()
    private selectedLatlng: string;
    @Input()
    private variable: string;
    @Input()
    private unit: string;

    private chartReady: boolean = false;
    private format = "highstock";
    private startDate: string = moment().subtract(151, 'days').format("YYYYMMDD");
    private endDate: string = moment().subtract(2, 'days').format("YYYYMMDD");

    //highstock options
    private options: Object;

    constructor(private service: HighStockService) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges ) {
        if (changes['selectedPeriod'] || changes['selectedLatlng'] || changes['unit']) {
            this.chartReady = false;
            this.service.getChartData(this.variable,
                this.startDate, this.endDate, this.selectedLatlng, this.format)
                .subscribe(res => {
                    //unit transformation
                    if (this.unit == "F") {
                        for (let ele of res) {
                            ele[1] = ele[1] * 1.8 + 32;
                        }
                    }
                    this.chartReady = true;
                    this.options = {
                        chart: {
                            width: 805,
                            height: 400,
                            marginRight: 7
                        },
                        // scroller under navigator is diabled
                        scrollbar: {
                            enabled: false
                        },
                        navigator: {
                            height: 20
                        },
                        rangeSelector: { selected: 1 },
                        title: { text: 'ARID - 150 days' },
                        yAxis: {
                            title: {
                                text: 'ARID Index',
                            }
                        },
                        series: [{
                            name: 'ARID Index',
                            data: res,
                            tooltip: {
                                valueDecimals: 2
                            }
                        }]
                    };
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/charts/high-stock-chart/high-stock-chart.component.ts